export const comments = [
  {
    id: 'c1',
    softwareId: 'gold-radar',
    user: '金市观察者',
    date: '2026-10-02',
    rating: 5,
    content: '到价提醒很及时，多端同步也方便，盯盘省心不少。',
  },
  {
    id: 'c2',
    softwareId: 'gold-radar',
    user: '稳健老李',
    date: '2026-09-30',
    rating: 4,
    content: '行情刷新快，希望自选分组能支持更多数量。',
  },
  {
    id: 'c3',
    softwareId: 'gold-trend-master',
    user: '指标控小陈',
    date: '2026-09-25',
    rating: 5,
    content: '指标库很全，形态识别对新手判断趋势帮助很大。',
  },
  {
    id: 'c4',
    softwareId: 'gold-trend-master',
    user: '追金一族',
    date: '2026-09-22',
    rating: 4,
    content: '回测功能实用，界面如果再简洁一点就更好了。',
  },
  {
    id: 'c5',
    softwareId: 'gold-mobile-quote',
    user: '每天看金价',
    date: '2026-09-18',
    rating: 5,
    content: '快讯更新很勤，财经日历提醒帮我避开了几次数据行情。',
  },
  {
    id: 'c6',
    softwareId: 'gold-wealth-butler',
    user: '定投达人',
    date: '2026-09-12',
    rating: 5,
    content: '定投计算和收益日报都很实用，理财规划清晰多了。',
  },
];